import { KeyboardArrowUp } from "@mui/icons-material";
import React, { useState } from "react";
import { motion } from "motion/react";

const Faq = () => {
  const [q, setQ] = useState(null);

  return (
    <div className="flex flex-col justify-center items-center lg:p-[4rem] p-[2rem]">
      <br />
      <h4 className="section-title black">Frequently Asked Questions</h4>
      <br />
      <div className=" grid lg:grid-cols-2 grid-cols-1 gap-5 w-full   outfit">
        {/* <div className="about-image-x w-full h-full"></div> */}
        {/* <div className="flex flex-col  gap-4"> */}

        <div className="grid grid-cols-1 gap-3 h-fit">
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 1) {
                return setQ(null);
              }
              return setQ(1);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What types of cargo does Saharawinds handle?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 1
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 1
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                We specialize in handling a wide range of cargo, including
                perishables like flowers, fruits, vegetables, seafood, and
                foodstuffs. Our team has the expertise and facilities to ensure
                your cargo remains in optimal condition from origin to
                destination.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 2) {
                return setQ(null);
              }
              return setQ(2);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                How do you handle customs and trade compliance for international
                shipments?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 2
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 2
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                Our experienced team manages all customs documentation and
                provides guidance on trade compliance, including certifications
                like phytosanitary and CTPAT, as well as adherence to trade
                protocols like AGOA, COMESA, and EU trade agreements.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 3) {
                return setQ(null);
              }
              return setQ(3);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                How can I get a quote or book a shipment with Saharawinds?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 3
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 3
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                Getting a quote or booking a shipment is easy! Simply reach out
                through our contact form, email, or call us directly. Our team
                will provide a customized quote and guide you through the
                booking process based on your specific needs.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 4) {
                return setQ(null);
              }
              return setQ(4);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What geographic regions do you cover?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 4
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 4
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                We operate both locally within East Africa and internationally.
                Thanks to our network of global partners, we provide
                door-to-door delivery options worldwide and maintain space
                protection agreements with major airlines and shipping lines.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 5) {
                return setQ(null);
              }
              return setQ(5);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                Can you manage both air and sea shipments?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 5
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 5
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                Yes, Saharawinds offers comprehensive air and sea logistics
                solutions. We handle everything from documentation and cargo
                consolidation to customs clearance, ensuring a smooth and
                reliable experience for imports and exports.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 6) {
                return setQ(null);
              }
              return setQ(6);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                How does Saharawinds ensure the quality of perishable goods
                during transit?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 6
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 6
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                We use advanced cold chain solutions, including
                temperature-controlled packaging, warehousing, and transport, to
                maintain the freshness and safety of perishable items.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 7) {
                return setQ(null);
              }
              return setQ(7);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What documents are required for shipping?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 7
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 7
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                While documentation requirements differ from country to country,
                the following are the minimum you will require for air freight
                shipping:
                <br />
                a) Commercial Invoice <br /> b) Air Waybill (AWB) for Air
                freight shipments <br />
                c) Bill of Lading (BL) for Ocean freight shipments <br />
                d) Packing List <br />
                e) Certificate of Origin
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 8) {
                return setQ(null);
              }
              return setQ(8);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                Do you provide door-to-door service or only airport-to-airport?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 8
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 8
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                Saharawinds provide air freight services that include
                door-to-door or airport-to-airport, whichever suits you best.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 9) {
                return setQ(null);
              }
              return setQ(9);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What other services are available in addition to air freight
                shipping?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 9
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 9
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                As a global logistics provider, Saharawinds Ltd offers a variety
                of air cargo logistics solutions, including customs clearance,
                consolidation, charter services, and global cross-trade
                services.
              </span>
            </motion.div>
          </div>

          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 10) {
                return setQ(null);
              }
              return setQ(10);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                How do you calculate chargeable weight for air freight?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 10
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 10
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                The chargeable weight (CW) of air freight is determined by the
                gross weight (GW) or the volume weight (VW), whichever is
                greater. The following formula is used to determine the
                chargeable weight:
                <br />L x W x H in centimetres (cm) / 6,000 = VW (in kgs)
              </span>
            </motion.div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-3 h-fit">
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 11) {
                return setQ(null);
              }
              return setQ(11);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                Are there limitations on the size and weight for shipped by air
                freight?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 11
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 11
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                Yes, there are limits to the size and weight of cargo that can
                be shipped by air freight. Consult Saharawinds Ltd to arrange
                freight of outsize cargo.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 12) {
                return setQ(null);
              }
              return setQ(12);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What is FCL shipping?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 12
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 12
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                FCL is a logistics acronym that stands for full container load.
                It means that a 20-foot or 40-foot shipping container is
                occupied by goods belonging to a single shipper.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 13) {
                return setQ(null);
              }
              return setQ(13);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What is LCL shipping?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 13
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 13
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                LCL is a logistics acronym that stands for
                less-than-container-load. It means that a 20-foot or 40-foot
                shipping container is filled with smaller consignments of goods
                belonging to multiple shippers. If you ship LCL, your goods will
                share container space with other shippers’ consignments.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 14) {
                return setQ(null);
              }
              return setQ(14);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What is consolidation/de-consolidation?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 14
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 14
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                These are terms used to denote loading multiple consignments
                into a single shipment for transport and the unloading and
                separation (deconsolidation) after arrival at the destination
                port.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 15) {
                return setQ(null);
              }
              return setQ(15);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                Do you provide door-to-door service or only port to port?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 15
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 15
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                We provide both door-to-door and port-to-port services for both
                air & ocean freight
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 16) {
                return setQ(null);
              }
              return setQ(16);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What do you mean by customs clearance?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 16
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 16
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                Before any shipment of goods can be imported or exported
                internationally, the goods are scrutinized by customs officials
                to ensure they conform to the relevant countries’ rules and
                regulations. Once satisfied with compliance, the customs
                authority will clear, or release, the shipment to travel freely
                across the border. To attain import customs clearance, the
                exporter or importer, in addition to providing correct and
                accurately completed documentation to customs officials, will
                typically be required to pay duties and perhaps taxes levied by
                the government of the country of import.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 17) {
                return setQ(null);
              }
              return setQ(17);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                How are duties and tariffs applied to my cargo?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 17
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 17
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                All goods being shipped across borders are subject to duties and
                tariffs that vary according to the applicable commodity (HS)
                code and the countries they are moving between. Customs
                officials use the HS code to determine what is being shipped and
                to apply the applicable tariffs and duties. Saharawinds will
                provide shippers with information on import and export
                clearance.
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 18) {
                return setQ(null);
              }
              return setQ(18);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What documents are needed for customs clearance?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 18
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 18
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                While lists may differ from one border entry point to another,
                in general, goods transiting international frontiers should be
                accompanied by the following documents:
                <br />
                a) Airway Bill/ Bill of lading
                <br />
                b) Commercial Invoice
                <br />
                c) Certificate of origin
                <br />
                d) Packing list
                <br />
                e) Proof of delivery
              </span>
            </motion.div>
          </div>
          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 19) {
                return setQ(null);
              }
              return setQ(19);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">
                What is the benefit of using Saharawinds Ltd to do my customs
                clearance?
              </span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 19
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 19
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                Saharawinds has experience in customs procedures, we will
                handles your customs clearance from beginning to end to ensure
                that your goods can be imported or exported seamlessly across
                borders. Our customs clearance specialists reduce the risk of
                enroute border delays, so your shipments arrive at their final
                destination on time and in full.
              </span>
            </motion.div>
          </div>

          <div
            className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl w-full h-fit cursor-pointer"
            onClick={() => {
              if (q === 20) {
                return setQ(null);
              }
              return setQ(20);
            }}
          >
            <div className="flex justify-between gap-3 items-center">
              <span className="font-bold text-lg text-">Cargo Insurance</span>
              <motion.div
                initial={{
                  rotate: 180,
                }}
                animate={
                  q === 20
                    ? {
                        rotate: 0,
                      }
                    : { rotate: 180, transition: { delay: 0.3 } }
                }
              >
                <KeyboardArrowUp />
              </motion.div>
            </div>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={
                q !== 20
                  ? {
                      height: 0,
                      opacity: 0,
                      transition: {
                        opacity: { delay: 0, duration: 0.3 },
                        height: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
                  : {
                      height: "auto",
                      opacity: 1,
                      transition: {
                        height: { delay: 0, duration: 0.3 },
                        opacity: {
                          delay: 0.3,
                          duration: 0.3,
                        },
                      },
                    }
              }
              className="pointer-events-none"
            >
              <span className="a">
                Carriers have limited liability for loss
                or damage to your goods under international conventions. In the
                case of an incident covered under international conventions,
                your compensation will be calculated against a standard
                negligent liability clause and not the real value of your cargo.
                While every shipment is handled with great care, accidents
                outside the carrier or freight forwarder’s control can happen.
                Natural disasters such as floods are not covered by freight
                liability. We recommend shippers to secure marine insurance
                cover to fully protect their shipments.
              </span>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
